import React, { useState } from "react";
import * as Icons from "lucide-react";
import { featuredServices, allServices } from "../mock";
import { Button } from "./ui/button";
import { ArrowRight, Plus } from "lucide-react";

export default function Services() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? allServices : allServices.slice(0, 12);

  return (
    <section id="services" className="pt-10 pb-20 sm:py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-widest text-cyan-700 font-bold">What We Do</div>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight">
            Website Internet Tech Mastery.
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Cutting-edge digital media marketing services and systems, powered by the latest AI technology to deliver
            targeted, impactful campaigns where most businesses haven&rsquo;t caught up.
          </p>
        </div>

        {/* Featured service cards */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {featuredServices.map((s) => {
            const Ic = Icons[s.icon] || Icons.Sparkles;
            return (
              <div
                key={s.title}
                className="group rounded-2xl overflow-hidden bg-white border border-slate-200 card-hover"
              >
                <div className="relative h-44 overflow-hidden">
                  <img src={s.img} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
                  <div className="absolute top-3 left-3 h-9 w-9 rounded-lg bg-white grid place-items-center shadow">
                    <Ic className="h-5 w-5 text-cyan-700" />
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-slate-900 text-lg">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                  <a
                    href="#contact"
                    className="mt-4 inline-flex items-center gap-1 text-cyan-700 font-semibold text-sm hover:gap-2 transition-all"
                  >
                    Learn more <ArrowRight className="h-4 w-4" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        {/* All services list */}
        <div className="mt-14">
          <h3 className="text-xl md:text-2xl font-bold text-slate-900">Full Service Menu</h3>
          <p className="text-sm text-slate-500 mt-1">A comprehensive variety tailored to meet your specific needs.</p>

          <div className="mt-6 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {visible.map((s) => {
              const Ic = Icons[s.icon] || Icons.Check;
              return (
                <div
                  key={s.name}
                  className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3 hover:border-cyan-500 hover:shadow-md transition-all"
                >
                  <div className="h-8 w-8 rounded-md bg-cyan-50 grid place-items-center flex-shrink-0">
                    <Ic className="h-4 w-4 text-cyan-700" />
                  </div>
                  <span className="text-sm font-medium text-slate-800">{s.name}</span>
                </div>
              );
            })}
          </div>

          {allServices.length > 12 && (
            <div className="mt-6 flex justify-center">
              <Button
                variant="outline"
                className="border-slate-300 text-slate-900 hover:bg-slate-100"
                onClick={() => setShowAll(!showAll)}
              >
                <Plus className="h-4 w-4 mr-2" />
                {showAll ? "Show Less" : `Show All ${allServices.length} Services`}
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
